import { useMutation } from 'react-query';
import axios from 'axios';

export const sendQuoteRequest = async (data: any) => {
  const base64EncodedData = window.btoa(JSON.stringify(data));
  const { data: response } = await axios.post(
    '/platform/api/v1/quoterequests',
    `"${base64EncodedData}"`,
    {
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
      },
    }
  );
  return response.data;
};

export function usePostQuoteRequest(onSuccess: Function, onError: Function) {
  return useMutation(sendQuoteRequest, {
    onSuccess: () => {
      onSuccess();
    },
    onError: () => {
      onError();
    },
  });
}
